@if ((showNavigationRedesign || isPublicNavigationEnabled()) && hasSideNavigation) {
  <ftr-app-layout [routeData]="routeData"><ng-container *ngTemplateOutlet="childContent" /></ftr-app-layout>
} @else if (isPublicNavigationEnabled()) {
  <ftr-app-layout-no-sidenav [routeData]="routeData"
    ><ng-container *ngTemplateOutlet="childContent"
  /></ftr-app-layout-no-sidenav>
} @else {
  <ftr-app-layout-legacy><ng-container *ngTemplateOutlet="childContent" /></ftr-app-layout-legacy>
}

<ng-template #childContent><ng-content /></ng-template>
